import './AddButton.css'
import { NavLink } from 'react-router-dom'

import { ReactComponent as AddButtonIcon } from '../../icon/add-button.svg'

const AddButton = (props) => {
	return (
		<NavLink onClick={props?.onClick} to={props?.to} className="add-button__link">
			<AddButtonIcon />
		</NavLink>
	)
}

export default AddButton
